import * as React from 'react';
import { ModalProps } from 'react-bootstrap';
// import { Editor } from 'react-draft-wysiwyg';
// import { EditorState, ContentState, convertToRaw } from 'draft-js';
// const draftToHtml: any = require('draftjs-to-html');
// const htmlToDraft: any = require('html-to-draftjs');
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Editor } from './tinymce-react/lib/cjs';

interface ModelContentProps extends ModalProps {
    title: string;
    content: string;
    extra?: any;
    defaultContent?: string;
}

export class PonderaEditModal extends React.Component<ModelContentProps, { content: string, defaultContent?: string}> {
    private editor: any;

    constructor(props: ModelContentProps) {
        super(props);

        var defaultContent = !this.props.defaultContent ? undefined : this.props.defaultContent;

        this.state = {
            content: this.props.content.trim().length === 0 && defaultContent ? defaultContent : this.props.content.trim(),
            defaultContent: defaultContent
        };
    }

    onHide(): any {
        var content = this.state.content;
        if (content.startsWith('<p>&nbsp;</p>')) {
            content = content.replace('<p>&nbsp;</p>', '');
        }
        if (content.endsWith('<p>&nbsp;</p>')) {
            content = content.substr(0, content.length - ('<p>&nbsp;</p>').length);
        }
        this.setState(
            {
                content
            },
            () => {
                this.props.onHide(content);
            });        
    }

    handleEditorChange = (content: string) => {
        this.setState({ content: content });
    }

    resetToDefault = () => {
        this.setState({ content: this.state.defaultContent! });
    }

    setup(ed: any) {
        ed.addButton('zigzag', {
            text: 'Zig Zag',
            icon: false,
            onclick: () => {
                ed.insertContent('<table class="table table-left-right-content table-zig-zag"><tbody><tr><td class="modal-content-container container-left" style="width: 50%;"><p>Left Content</p></td><td class="modal-content-container container-right"><p>Right Content</p></td></tr></tbody></table>');
            }
        });
        ed.addButton('zigzagfull', {
            text: 'Zig Zag Full',
            icon: false,
            onclick: () => {
                ed.insertContent('<div class="zig-zag-full"><p>Left Content</p></div>');
            }
        });
    }

    render() {
        if (!this.props.show) {
            return <div />;
        }

        return (
            <div className="modal-container">
                <div className="row">
                    <div className="col-xs-offset-3 col-xs-6">
                        <div className="modal-dialog">
                            <div className="modal-content" role="document">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={(e) => this.onHide()}>
                                        <span aria-hidden="true">×</span>
                                        <span className="sr-only">Close</span>
                                    </button>
                                    <h4 className="modal-title">{this.props.title}</h4>
                                </div>
                                <div className="modal-body" style={{minHeight: '300px'}}>
                                    <Editor
                                        ref={(e) => this.editor = e}
                                        value={this.state.content}
                                        init={{ minHeight: '300px', height: '300px', plugins: 'link image code table lists textcolor', toolbar: 'undo redo | bold italic forecolor | alignleft aligncenter alignright | bullist numlist | code | zigzag | zigzagfull', setup: this.setup }}
                                        onEditorChange={this.handleEditorChange}
                                        apiKey={'3ct97nwkjybnozqth8i1ym0ut8bkidly366xskckxq6w0sro'}
                                    />
                                    {this.props.extra}
                                </div>
                                <div className="modal-footer">
                                    { this.state.defaultContent && 
                                        <button onClick={(e) => this.resetToDefault()} type="button" className="btn btn-danger pull-left">Reset to Default</button> 
                                    }
                                    <button onClick={(e) => this.onHide()} type="button" className="btn btn-default">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/inclinationmodals/PonderaEditModal.tsx